import Layout from "../layout/layout";
const Reports=()=>{
    return(<>
    <Layout />
    </>);
}
export default Reports;